module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ed-Fb-Gb.778e9bd4.png";